<template>
    <div>
        <div class="loader" v-if="this.isLoading"></div>
        <div class="loadertext" v-if="this.isLoading"> {{ $t('loadingTxt') }}...</div>
        <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
            <!--begin::sidebar-->
            <sidebar-component classMenu="AccidentAdd"></sidebar-component>
            <!--end::sidebar-->

            <div class="page-wrapper">
                <!--begin::navbar-->
                <navbar-component></navbar-component>
                <!--end::navbar-->

                <!--begin::content-->
                <div class="page-content">
                    <div class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            ">
                        <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                            <div class="card">
                                <div class="card-header">
                                    <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                                    &nbsp;&nbsp;&nbsp;
                                    <h6 class="card-title mb-0 float-start" style="padding-left: 25px">
                                        Penerimaan Edit
                                    </h6>
                                    <button class="btn btn-default btn-sm float-end" @click="resetForm" type="button">
                                        <i class="link-icon" data-feather="repeat"></i>
                                        {{ $t("resetFormTxt") }}
                                    </button>
                                </div>
                                <div class="card-body">
                                    <!--begin::loading-data-->
                                    <div v-if="isLoading" class="d-flex align-items-center">
                                        <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                                        <strong>{{ $t("loadingTxt") }}...</strong>
                                    </div>
                                    <!--end::loading-data-->

                                    <form ref="formElement" class="forms-sample" @submit.prevent="submitData"
                                        method="POST">
                                        <div class="
                        d-flex
                        justify-content-between
                        align-items-baseline
                        mb-2
                      "></div>




                                        <!-- DATA ORDER -->
                                        <div class="card mb-3">
                                            <div class="card-header ">DATA ORDER</div>
                                            <div class="card-body">
                                                <div class="row mb-2">
                                                    <div class="col-md-3">
                                                        <label>Load Id</label>

                                                        <multiselect v-model="dataOrder.loadId" disabled
                                                            @search-change="asyncSearchLoadId" @input="selectChangeLoad"
                                                            :options="fetchLoadId" placeholder="Type to search "
                                                            track-by="load_id" label="load_id"><span
                                                                slot="noResult">Oops! No elements found. Consider
                                                                changing the
                                                                search query.</span></multiselect>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label>Jenis Truck</label>
                                                        <input type="text" class="form-control"
                                                            v-model="dataOrder.type_truck" disabled>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label>NMK Driver</label>
                                                        <input type="text" class="form-control"
                                                            v-model="dataOrder.nmkDriver" disabled>



                                                    </div>
                                                    <div class="col-md-3">
                                                        <label>Nopol</label>
                                                        <input disable type="text" class="form-control"
                                                            v-model="dataOrder.nopol" disabled>
                                                    </div>
                                                </div>
                                                <div class="row mb-2">
                                                    <div class="col-md-3">
                                                        <label>Nama Driver</label>
                                                        <input type="text" class="form-control"
                                                            v-model="dataOrder.namaDriver" disabled>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label>Driver Deposit</label>
                                                        <input type="text" class="form-control"
                                                            v-model="dataOrder.driver_deposit" disabled>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label>Carrier</label>
                                                        <input type="text" class="form-control"
                                                            v-model="dataOrder.carrier" disabled>
                                                    </div>
                                                </div>

                                                <!-- Table Data Order -->

                                                <div class="d-flex justify-content-end mb-2">
                                                    <!-- <span class="btn-success btn-sm  cursor-pointer"
                                                        @click="tambahOrder">
                                                        <i class="mdi mdi-plus"></i>
                                                    </span> -->
                                                </div>

                                                <div class="table-responsive">
                                                    <table class="table table-bordered mt-3">
                                                        <thead class="table-light">
                                                            <tr>

                                                                <th>Order No</th>
                                                                <th>Customer Code</th>
                                                                <th>Customer Name</th>
                                                                <th>Sap Code</th>
                                                                <th>Tanggal Order</th>
                                                                <th>Pick Plan</th>
                                                                <th>Pick Name</th>
                                                                <th>Drop Plan</th>
                                                                <th>Drop Name</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item, idx) in dataOrder.orders" :key="idx">
                                                                <!-- Action -->


                                                                <!-- Order No -->
                                                                <td>


                                                                    {{ item.orderNo.order_no }}
                                                                </td>

                                                                <td>{{ item.customerCode }}</td>
                                                                <td>{{ item.customerName }}</td>
                                                                <td>{{ item.sapCode }}</td>
                                                                <td>{{ item.tanggalOrder }}</td>
                                                                <td>{{ item.pickPlan }}</td>
                                                                <td>{{ item.pickName }}</td>
                                                                <td>{{ item.dropPlan }}</td>
                                                                <td>{{ item.dropName }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                        </div>

                                        <!-- DATA KLAIM -->
                                        <div class="card mb-3">
                                            <div class="card-header">DATA KLAIM</div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <!-- Kolom kiri -->
                                                    <div class="col-md-6">
                                                        <div class="row mb-2">
                                                            <div class="col-md-4">
                                                                <label>Aging (D)</label>
                                                                <input disabled type="text"
                                                                    class="form-control form-control-sm"
                                                                    v-model="dataKlaim.aging">
                                                            </div>
                                                            <div class="col-md-8">
                                                                <label>No Klaim</label>
                                                                <input disabled type="text"
                                                                    class="form-control form-control-sm"
                                                                    v-model="dataKlaim.noKlaim">
                                                            </div>
                                                        </div>

                                                        <div class="mb-2">
                                                            <label>Cabang</label>
                                                            <input disabled type="text"
                                                                class="form-control form-control-sm" di
                                                                v-model="this.dataOrder.branch_name">
                                                        </div>

                                                        <div class="row mb-2">
                                                            <div class="col-md-6">
                                                                <label>NMK Driver</label>


                                                                <!-- <select class="form-select form-select-sm"
                                                                    v-model="dataKlaim.nmkDriver">
                                                                    <option>NMK5678 / N7th</option>
                                                                </select> -->

                                                                <multiselect disabled v-model="dataKlaim.nmkDriver"
                                                                    @search-change="asyncSearchNmkDriver"
                                                                    @input="selectNmkDriver" :options="fetchNmkDriver"
                                                                    placeholder="Type to search " track-by="nmk"
                                                                    label="nmk"><span slot="noResult">Oops! No elements
                                                                        found. Consider changing the
                                                                        search query.</span></multiselect>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <label>Nama Driver</label>
                                                                <input disabled type="text"
                                                                    class="form-control form-control-sm"
                                                                    v-model="dataKlaim.namaDriver">



                                                            </div>
                                                        </div>

                                                        <div class="row mb-2">
                                                            <div class="col-md-6">
                                                                <label>Nopol</label>
                                                                <!-- <select class="form-select form-select-sm"
                                                                    v-model="dataKlaim.nopol">
                                                                    <option>B8967SCQ</option>
                                                                </select> -->

                                                                <multiselect disabled v-model="dataKlaim.nopol"
                                                                    @search-change="asyncSearchNmkDriver"
                                                                    @input="selectNopol" :options="fetchNopol"
                                                                    placeholder="Type to search " track-by="vehicle_no"
                                                                    label="vehicle_no"><span slot="noResult">Oops! No
                                                                        elements found. Consider changing the
                                                                        search query.</span></multiselect>



                                                            </div>
                                                            <div class="col-md-6">
                                                                <label>Jenis Truck</label>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    v-model="dataKlaim.type_truck" disabled>
                                                            </div>
                                                        </div>

                                                        <div class="row mb-2">
                                                            <div class="col-md-6">
                                                                <label>Tanggal Kejadian</label>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    v-model="dataKlaim.tglKejadian" disabled>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <label>Jam</label>
                                                                <input type="text" class="form-control form-control-sm"
                                                                    v-model="dataKlaim.jamKejadian" disabled>
                                                            </div>
                                                        </div>

                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                  <label>Tanggal Pengajuan</label>
                                                                <input type="text" class="form-control form-control-sm"
                                                                v-model="dataKlaim.tglPengajuan" disabled>
                                                            </div>
                                                          
                                                        </div>
                                                        


                                                       
                                                        <div class="row">
                                                             <div class="col-md-12">
                                                                  <label>Customer Claim Date</label>
                                                             <date-range-picker style="width: 100%"
                                                                :locale-data="localeP" 
                                                                v-model="dataKlaim.customer_claimed_date" opens="center"
                                                                :singleDatePicker="true" :timePicker="false">
                                                            </date-range-picker>
                                                             </div>
                                                           
                                                        </div>
                                                        
                                                        
                                                    </div>

                                                    <!-- Kolom kanan -->
                                                    <div class="col-md-6">
                                                        <div class="mb-2">
                                                            <label>Status Klaim</label>
                                                            <!-- <input type="text" class="form-control form-control-sm"
                                                                v-model="dataKlaim.status" readonly> -->

                                                            <v-select :options="fetchStatusClaim" v-model="status_claim"
                                                                v-bind:style="{ padding: 0 }" class="form-control"
                                                                label="name" return-object></v-select>

                                                        </div>

                                                        <div class="mb-2">
                                                            <label>Sumber Informasi</label>
                                                            <!-- <select class="form-select form-select-sm"
                                                                v-model="dataKlaim.sumberInfo">
                                                                <option>Customer</option>
                                                                <option>Vendor</option>
                                                            </select> -->

                                                            <v-select :options="fetchSumberInformasi" disabled
                                                                v-model="dataKlaim.sumberInfo"
                                                                v-bind:style="{ padding: 0 }" class="form-control"
                                                                label="code" return-object></v-select>
                                                        </div>

                                                        <div class="mb-2">
                                                            <label>Laporan Kejadian</label>

                                                            <div v-html="dataKlaim.laporan"></div>
                                                            <!-- <ckeditor :key="'laporan'" v-model="dataKlaim.laporan"
                                                                :config="editorConfig">
                                                            </ckeditor> -->


                                                            <!-- <TinymceEditor
                                                                    v-model="dataKlaim.laporan"
                                                                    :init=" {
                                                                        base_url: '/tinymce', // folder public/tinymce
                                                                        suffix: '.min',
                                                                        plugins: 'image link media code table',
                                                                        toolbar: 'undo redo | styles | bold italic | alignleft aligncenter alignright | image link media code table',
                                                                        menubar: 'file edit view insert format tools table help',
                                                                        readonly: false
                                                                    }"
                                                                /> -->



                                                        </div>

                                                        <div class="mt-2">
                                                            <label>Hasil Pemeriksaan</label>
                                                            <div v-html="dataKlaim.pemeriksaan"></div>
                                                            <!-- <ckeditor :key="'pemeriksaan'" :disabled="true"
                                                                v-model="dataKlaim.pemeriksaan" :config="editorConfig">
                                                            </ckeditor> -->
                                                            <!-- <input type="text" class="form-control form-control-sm"
                                                                v-model="dataKlaim.pemeriksaan"> -->

                                                            <!-- <TinymceEditor
                                                                    v-model="dataKlaim.pemeriksaan"
                                                                    :init=" {
                                                                        base_url: '/tinymce', // folder public/tinymce
                                                                        suffix: '.min',
                                                                        plugins: 'image link media code table',
                                                                        toolbar: 'undo redo | styles | bold italic | alignleft aligncenter alignright | image link media code table',
                                                                        menubar: 'file edit view insert format tools table help',
                                                                        readonly: false
                                                                    }"
                                                                /> -->
                                                            <!-- <vue2-tinymce-editor  :key="'editor-pemeriksaan'" id="editor-pemeriksaan" v-model="dataKlaim.pemeriksaan"></vue2-tinymce-editor> -->
                                                        </div>

                                                        <div class="mt-2">
                                                            <label>Penyelesaian</label>
                                                            <div v-html="dataKlaim.penyelesaian"></div> 
                                                        </div>



                                                        <div class="mt-2">
                                                            <label>Catatan</label>

                                                            <div v-if="this.status_claim.name != 'KOREKSI'" v-html="dataKlaim.comment"></div> 
                                                            <div v-else>

                                                                <ckeditor v-model="dataKlaim.comment" :config="editorConfigInsert"></ckeditor>

                                                            </div>


                                                        </div>


                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <!-- DETAIL KLAIM -->
                                        <div class="card mb-3">
                                            <div class="card-header d-flex justify-content-between align-items-center">
                                                <span>DETAIL KLAIM</span>
                                                <!-- <span class="btn btn-success btn-sm" @click="tambahDetail">
                                                    <i class="mdi mdi-plus"></i>
                                                </span> -->
                                            </div>

                                            <div class="card-body">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered align-middle">
                                                        <thead class="table-light text-center">
                                                            <tr>
                                                                <th style="width: 40px;">No</th>

                                                                <th>Produk</th>
                                                                <th>Keterangan</th>
                                                                <th>Klaim ke</th>
                                                                <th>Kategori</th>
                                                                <th style="width: 100px;">Jumlah</th>
                                                                <th>Type Paket</th>
                                                                <th style="width: 120px;">Harga per Paket</th>
                                                                <th>Total</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(detail, idx) in dataKlaim.details" :key="idx">
                                                                <td class="text-center">{{ idx + 1 }}</td>

                                                                <td>{{ detail.produk }}</td>
                                                                <td>{{ detail.keterangan }}</td>
                                                                <td>
                                                                    {{ detail.klaimKe }}
                                                                    <!-- <select class="form-select form-select-sm"
                                                                        v-model="detail.klaimKe">
                                                                        <option value="Vendor">Vendor</option>
                                                                        <option value="Driver">Driver</option>
                                                                    </select> -->
                                                                </td>
                                                                <td>
                                                                    {{ detail.kategori }}
                                                                    <!-- <select class="form-select form-select-sm"
                                                                        v-model="detail.kategori">
                                                                        <option value="Claim DG">Claim DG</option>
                                                                        <option value="Claim DP">Claim DP</option>
                                                                    </select> -->
                                                                </td>
                                                                <td>
                                                                    <!-- <input class="form-control form-control-sm text-end"
                                                                        type="number" v-model.number="detail.jumlah"> -->
                                                                    {{ detail.jumlah }}
                                                                </td>
                                                                <td>
                                                                    {{ detail.typePaket }}
                                                                    <!-- <select class="form-select form-select-sm"
                                                                        v-model="detail.typePaket">
                                                                        <option value="Kilogram">Kilogram</option>
                                                                        <option value="Karton">Karton</option>
                                                                    </select> -->
                                                                </td>
                                                                <td>
                                                                    {{ detail.harga }}
                                                                    <!-- <input class="form-control form-control-sm text-end"
                                                                        type="number" v-model.number="detail.harga"> -->
                                                                </td>
                                                                <td> {{ formatCurrency(detail.jumlah * detail.harga) }}
                                                                </td>

                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>


                                                <!-- Ringkasan Klaim -->
                                                <div class="row mt-3">
                                                    <div class="col-md-3 offset-md-9">
                                                        <div class="mb-2 d-flex justify-content-between">
                                                            <label><strong>Total Klaim</strong></label>
                                                            <input class="form-control form-control-sm text-end"
                                                                :value="formatCurrency(totalKlaim)" readonly>
                                                        </div>
                                                        <div class="mb-2 d-flex justify-content-between">
                                                            <label>Beban Klaim Vendor</label>
                                                            <input class="form-control form-control-sm text-end"
                                                                v-model="bebanVendor" readonly>
                                                        </div>
                                                        <div class="mb-2 d-flex justify-content-between">
                                                            <label>Beban Klaim Driver</label>
                                                            <input class="form-control form-control-sm text-end"
                                                                v-model="bebanDriver" readonly>
                                                        </div>
                                                        <div class="d-flex justify-content-between">
                                                            <label>Beban Klaim Kantor</label>
                                                            <input class="form-control form-control-sm text-end"
                                                                v-model="bebanKantor" readonly>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <!-- LAMPIRAN -->
                                        <div class="card mb-3">
                                            <div class="card-header d-flex justify-content-between align-items-center">
                                                <span>LAMPIRAN</span>
                                                <!-- <span class="btn btn-success btn-sm" @click="tambahClaimFile">
                                                    <i class="mdi mdi-plus"></i>
                                                </span> -->
                                            </div>
                                            <div class="card-body">
                                                <table class="table table-bordered">
                                                    <thead class="table-light">
                                                        <tr>
                                                            <th style="width: 50px;">No</th>
                                                            <!-- <th style="width: 70px;">Action</th> -->
                                                            <th>Nama</th>
                                                            <th>File</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(lamp, idx) in lampiran" :key="idx">
                                                            <td class="text-center">{{ idx + 1 }}</td>
                                                            <!-- <td class="text-center">
                                                                <span class="btn btn-danger btn-sm"
                                                                    @click="hapusClaimFile(idx)">
                                                                    <i class="mdi mdi-delete"></i>
                                                                </span>
                                                            </td> -->
                                                            <td>
                                                                {{ lamp.nama }}
                                                            </td>
                                                            <td>
                                                                <a :href=lamp.file class="btn btn-sm"
                                                                    target="_blank">Download</a>
                                                                <!-- <input type="file" class="form-control"
                                                                    @change="onFileChange($event, idx)"> -->
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>






                                        <div class="card mb-3">
                                            <div class="card-header d-flex justify-content-between align-items-center">

                                                <!-- kiri -->
                                                <div class="d-flex align-items-center gap-2 flex-grow-1">
                                                    <span class="me-2">KEPUTUSAN</span>
                                                    <v-select :options="fetchDecisionClaim" v-model="decision_claim"
                                                        class="form-control w-50" label="name" return-object>
                                                    </v-select>
                                                </div>

                                                <!-- kanan -->
                                                <span class="btn btn-success btn-sm ms-2" @click="tambahClaimDecision">
                                                    <i class="mdi mdi-plus"></i>
                                                </span>
                                            </div>

                                            <div class="card-body">
                                                <div class="row">


                                                </div>
                                                <table class="table table-bordered">
                                                    <thead class="table-light">
                                                        <tr>
                                                            <th style="width: 50px;">No</th>
                                                            <th style="width: 70px;">Action</th>
                                                            <th>No Dokumen</th>
                                                            <th>Tanggal Dokumen</th>
                                                            <th>Currency</th>
                                                            <th>Jumlah Pembayaran</th>
                                                            <th>Comment</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(lamp, idx) in claim_decision" :key="idx">
                                                            <td class="text-center">{{ idx + 1 }}</td>
                                                            <td class="text-center">
                                                                <span class="btn btn-danger btn-sm"
                                                                    @click="hapusClaimDecision(idx)">
                                                                    <i class="mdi mdi-delete"></i>
                                                                </span>
                                                            </td>
                                                            <td>

                                                                <input class="form-control" name="claim_number"
                                                                    type="text" v-model="lamp.claim_number" />
                                                            </td>

                                                            <td>
                                                                <date-range-picker style="width: 100%"
                                                                    :locale-data="locale" v-model="lamp.payment_date"
                                                                    opens="center" :singleDatePicker="true"
                                                                    :timePicker="true">
                                                                </date-range-picker>
                                                            </td>

                                                            <td>


                                                                <v-select :options="fetchCurrency"
                                                                    v-model="lamp.currency" return-object></v-select>
                                                            </td>


                                                            <td>

                                                                <input class="form-control" name="payment_amount"
                                                                    type="number" v-model="lamp.payment_amount" />


                                                            </td>

                                                            <td>

                                                                <input class="form-control" name="comment" type="text"
                                                                    v-model="lamp.comment" />
                                                            </td>



                                                        </tr>
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td colspan="5"><b>Total Pembayaran</b></td>
                                                            <td><b>{{ formatCurrency(totalPembayaran) }}</b></td>

                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>









                                        <div class="card-footer">
                                            <button class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        " @click="backForm" type="button">
                                                <i class="link-icon" data-feather="arrow-left"></i>
                                                {{ $t("backMess") }}
                                            </button>
                                            &nbsp;&nbsp;&nbsp;
                                            <button class="btn btn-primary float-end btn-sm" type="submit">
                                                <i class="link-icon" data-feather="save"></i>
                                                {{ $t("submitFormTxt") }}
                                            </button>
                                        </div>

                                    </form>
                                </div>
                            </div>
                            <!--end::card-->
                        </div>
                    </div>
                </div>
                <!--end::content-->
                <!-- <modal-unloading :showModal="showModalUnloading" :data="this.dataModal" @closeModal="closeMyModal">
                </modal-unloading> -->

                <!--begin::footer-->
                <footer-component></footer-component>
                <!--end::footer-->
            </div>
        </div>
    </div>
</template>





<script>


import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import myMixinAddress from '@/middleware/mixinAddress.js';
// import Datepicker from "vuejs-datepicker";
import multiselect from "vue-multiselect";
import moment from 'moment'
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
//import moment from 'moment'
// import modalUnloading from "@/components/modal/modalUnloading.vue";
// import CurrencyInput from "@/components/_partials/inputCurrency";
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
    name: "PengajuanAdd",
    props: {},
    mixins: [myMixinAddress],
    components: {
        "sidebar-component": sidebarComponent,
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
        // "modal-unloading": modalUnloading,
        multiselect: multiselect,
        // CurrencyInput,
        DateRangePicker
    },
    data() {
        const startDate = new Date();
        const endDate = new Date();
        return {
            disabledBeforeLoad: true,
            vehicle_no: "",
            bebanVendor: 0,
            bebanKantor: 0,
            bebanDriver: 0,
            fetchDecisionClaim: [],
            fetchStatusClaim: [
                {
                    name: 'DITERIMA',
                },
                {
                    name: 'KOREKSI',
                }
            ],
            decision_claim: "",
            status_claim: "",
            fetchVehicleNo: [],
            opens: "center",
            category: '',
            fetchCategory: [],

            orderNoList: [

            ],

            editorData: '<p>Halo, ini CKEditor 4 gratis!</p>',
            editorConfig: {
                versionCheck: false,
                readOnly: true,   // ⬅️ langsung set readOnly
                toolbar: [
                    { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'Undo', 'Redo'] },
                    { name: 'editing', items: ['Find', 'Replace', 'SelectAll'] },
                    { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'RemoveFormat'] },
                    { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] },
                    { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
                    { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'Smiley'] },
                    { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
                    { name: 'colors', items: ['TextColor', 'BGColor'] },
                    { name: 'tools', items: ['Maximize', 'ShowBlocks', 'Source'] }
                ]
            },
            editorConfigInsert: {
                versionCheck: false,
                readOnly: false,   // ⬅️ langsung set readOnly
                toolbar: [
                    { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'Undo', 'Redo'] },
                    { name: 'editing', items: ['Find', 'Replace', 'SelectAll'] },
                    { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'RemoveFormat'] },
                    { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] },
                    { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
                    { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'Smiley'] },
                    { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
                    { name: 'colors', items: ['TextColor', 'BGColor'] },
                    { name: 'tools', items: ['Maximize', 'ShowBlocks', 'Source'] }
                ]
            },


            fetchSumberInformasi: [],
            // dataOrder: {
            //     orders: []
            // },

            driver_nmk: "",
            fetchDriverNmk: [],
            fetchAccidentArea: [],
            fetchHaul: ['Short Haul', 'Long Haul'],
            haul: '',
            penyebab_langsung: '',
            accident_area: '',
            fetchPenyebabLangsung: [],
            caused: '',
            fetchCaused: [],

            fetchKerusakan: [],
            kerusakans: '',
            fetchTipeKejadian: [],
            tipe_kejadians: '',
            fetchPenyebabDasar: [],
            penyebab_dasars: '',

        

            accident_date: {
                startDate,
                endDate,
            },



            locale: {
                format: "dd mmm yyyy H:MM:ss",
                separator: ' - ',
            },

            localeP: {
                format: "dd mmm yyyy",
                separator: ' - ',
            },


            active_date: {
                startDate: null,
                endDate: null
            },

            fetchNmkDriver: [],
            fetchNopol: [],

            accident_date_complete: {
                startDate: null,
                endDate: null
            },


            fetchCaseResult: [],
            case_result: "",
            claim_id: "",
            rate: '',
            fetchRate: [],

            fetchLoadNumber: [],
            loadNumber: [],
            fetchCategoryStatus: [],

            fetchDirectCauseDetail: [],
            directCauseDetail: "",

            fetchCurrency: [],
            fetchProvinsiTujuan: [],
            ProvinsiTujuan: [],

            fetchKotaTujuan: [],
            KotaTujuan: [],

            fetchSubCustomer: ['Industrial', 'Consumer', 'MT', 'Pallet', 'E-COM'],
            SubCustomer: [],

            showModalUnloading: false,

            isLoading: false,
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            errors: [],
            permision_role: [],
            userData: "",
            companyCode: "",
            forms: {

            },


            disabledDate: {},
            dataModal: {},
            fetchLoadId: [],
            load_id: "",


            dataOrder: {
                loadId: '',
                type_truck: '',
                nmkDriver: '',
                driver_deposit: '',
                driver_number: '',
                nopol: '',
                namaDriver: '',
                carrier: '',
                branch_name: '',
                orders: [

                ]
            },
            dataKlaim: {
                aging: 0,
                status: 'NEW',
                noKlaim: '',
                sumberInfo: 'Customer',
                cabang: 'Jakarta',
                laporan: '',
                nmkDriver: '',
                namaDriver: '',
                pemeriksaan: '',
                penyelesaian: '',
                    customer_claimed_date:{
                        startDate,
                        endDate,
                    },
                details: [
                    { produk: 'Kertas CME', keterangan: 'Produk Jadi', klaimKe: 'Vendor', kategori: 'Claim DG', jumlah: 42, typePaket: 'Kilogram', harga: 50000 }
                ]
            },
            lampiran: [
                { nama: 'Berita Acara', file: null }
            ],
            claim_decision: [

            ]


        };
    },



    watch: {
       'dataKlaim.tglPengajuan'(newDate) {
            if (!newDate.startDate) {
                this.dataKlaim.aging = '';
                return;
            }

            const today = new Date();
            const selectedDate = new Date(newDate.startDate);

            // reset jam ke 00:00:00
            today.setHours(0, 0, 0, 0);
            selectedDate.setHours(0, 0, 0, 0);

            // hitung selisih dalam hari (selalu positif)
            const diffTime = Math.abs(selectedDate - today);
            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

            this.dataKlaim.aging = diffDays;
        },

        'dataKlaim.laporan'(val) {
            if (this.$refs.editorLaporan) {
                this.$refs.editorLaporan.editor.setData(val || '');
            }
        },
        'dataKlaim.pemeriksaan'(val) {
            if (this.$refs.editorPemeriksaan) {
                this.$refs.editorPemeriksaan.editor.setData(val || '');
            }
        },
        'dataKlaim.penyelesaian'(val) {
            if (this.$refs.editorPenyelesaian) {
                this.$refs.editorPenyelesaian.editor.setData(val || '');
            }
        },
        'dataKlaim.catatan'(val) {
            if (this.$refs.editorCatatan) {
                this.$refs.editorCatatan.editor.setData(val || '');
            }
        }


    },
    computed: {
        totalKlaim() {
            return this.dataKlaim.details.reduce((sum, d) => sum + (d.jumlah * d.harga), 0);
        },

        totalPembayaran() {
            return this.claim_decision.reduce((sum, d) => {
                const amount = parseFloat(d.payment_amount) || 0;
                return sum + amount;
            }, 0);
        }
    },
    methods: {

        selectNmkDriver(ev) {
            this.dataKlaim.namaDriver = ev.driver_name
        },

        selectNopol(ev) {
            this.dataKlaim.type_truck = ev.type_truck;
        },
        openMap() {

        },
        changeDisabled(ev) {
            this.forms.complete_date = "";
            this.disabledDate = {
                to: ev,
            }
        },
        clearLoad() {


        },

        formatCurrency(value) {
            return new Intl.NumberFormat('id-ID', {
                style: 'currency',
                currency: 'IDR'
            }).format(value || 0);
        },

        loadVehicleNo() {
            const baseURI =
                this.$settings.endPointCt + `master-truck`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchVehicleNo = response.data.datas.data;
            });
        },

        loadDriverNmk() {
            const baseURI =
                this.$settings.endPointCt + `master-driver`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchDriverNmk = response.data.datas.data;

            });
        },

        selectDriverNmk(driver) {
            this.forms.vehicle_owner = driver.branch_name;
        },

        selectAccidentArea(accident) {
            if (this.forms.vehicle_owner == accident) {
                this.haul = "Short Haul";
            }
        },

        loadSumberInformasi() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=sumInf`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchSumberInformasi = response.data.datas;

            });
        },

        loadKeputusan() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=clmkep`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchDecisionClaim = response.data.datas;

            });
        },

        tambahDetail() {
            this.dataKlaim.details.push({
                produk: '',
                keterangan: '',
                klaimKe: 'Vendor',
                kategori: 'Claim DG',
                jumlah: 0,
                typePaket: 'Kilogram',
                harga: 0
            });
        },
        hapusDetail(index) {
            this.dataKlaim.details.splice(index, 1);
        },



        loadCause() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=cauac`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchCaused = response.data.datas;
            });
        },

        loadRate() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=ratac`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchRate = response.data.datas;
            });
        },

        loadPenyebabLangsung() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=dirca`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchPenyebabLangsung = response.data.datas;
            });
        },

        loadDirectCauseDetail() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=penla`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchDirectCauseDetail = response.data.datas;
            });
        },
        loadCaseResult() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=casre`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchCaseResult = response.data.datas;
            });
        },

        selectChangeLoad(ev) {
            this.dataOrder.type_truck = ev.type_truck;
            this.dataOrder.nmkDriver = ev.driver_id;
            this.dataOrder.nopol = ev.vehicle_no;
            this.dataOrder.namaDriver = ev.driver_name;
            this.dataOrder.carrier = ev.carrier
            this.dataOrder.driver_number = ev.driver_number;
            this.dataOrder.branch_name = ev.branch_name;
            this.dataKlaim.nmkDriver = {
                nmk: ev.driver_id,
                driver_name: ev.driver_name
            }

            this.dataKlaim.namaDriver = ev.driver_name;


            this.dataKlaim.nopol = {
                vehicle_no: ev.vehicle_no,
                type_truck: ev.type_truck

            }

            this.dataKlaim.type_truck = ev.type_truck;

            this.loadordeNo(ev.load_id)
            if (ev.driver_id != null) {
                this.loadDriverDeposit(ev.driver_id)
            }

        },

        asyncSearchNmkDriver(ev) {
            const baseURI =
                this.$settings.endPointCt + `driver-nmk/get-data-nmks?limit=999999&nmk=${ev}`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchNmkDriver = response.data.datas;
            });
        },

        loadNmkDriver() {
            const baseURI =
                this.$settings.endPointCt + `driver-nmk/get-data-nmks?limit=999999`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchNmkDriver = response.data.datas.data;
            });
        },


        asyncSearchNopol(ev) {
            const baseURI =
                this.$settings.endPointCt + `master-truck?limit=10&vehicle_no=${ev}`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchNopol = response.data.datas;
            });
        },

        loadNopol() {
            const baseURI =
                this.$settings.endPointCt + `master-truck?limit=10`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchNopol = response.data.datas.data;
            });
        },


        loadTipeKejadian() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=kejad`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchTipeKejadian = response.data.datas;
            });
        },

        loadKerusakan() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=kerus`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchKerusakan = response.data.datas;
            });
        },

        loadPenyebabDasar() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=sebab`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchPenyebabDasar = response.data.datas;
            });
        },

        loadAccidentArea() {
            const baseURI =
                this.$settings.endPointCt + `branch`;
            return this.$http.get(baseURI).then((response) => {
                var resp = response.data.datas;
                for (let index = 0; index < resp.data.length; index++) {
                    const branch = resp.data[index].branch_name;
                    this.fetchAccidentArea.push(branch);
                }
                // var data={
                //   resp.data.branch_name
                // }
                //this.fetchAccidentArea = response.data.datas;
            });
        },

        asyncSearchDriverNmk(ev) {
            const baseURI =
                this.$settings.endPointCt + `master-driver?driver_id=` + ev;
            return this.$http.get(baseURI).then((response) => {
                this.fetchDriverNmk = response.data.datas.data;
            });
        },


        asyncSearchVehicleNo(ev) {
            const baseURI =
                this.$settings.endPointCt + `master-truck?vehicle_no=` + ev;
            return this.$http.get(baseURI).then((response) => {
                this.fetchVehicleNo = response.data.datas.data;
            });
        },


        loadLoadId() {
            const baseURI = this.$settings.endPoint + `claim/get-data-loadid-claim`;

            return this.$http.get(baseURI).then((response) => {
                this.fetchLoadId = response.data.datas.data;
            });

        },


        loadordeNo(load_id) {
            const baseURI = this.$settings.endPoint + `/claim/get-order-by-loadid/` + load_id;

            return this.$http.get(baseURI).then((response) => {
                this.orderNoList = response.data.datas;
            });

        },

        loadDriverDeposit(nmk_driver) {
            const baseURI = this.$settings.endPoint + `/claim/get-saldo-akhir-driver/` + nmk_driver;

            return this.$http.get(baseURI).then((response) => {
                let driver = response.data.datas;
                this.dataOrder.driver_deposit = driver?.saldo_akhir;
            });

        },

        tambahClaimFile() {
            this.lampiran.push({ nama: '', file: null });
        },

        tambahClaimDecision() {
            const startDate = new Date();
            const endDate = new Date();
            this.claim_decision.push({
                claim_number: '', payment_date: {
                    startDate: startDate,
                    endDate: endDate
                }, payment_amount: 0, currency: 'IDR', comment: ''
            });
        },

        hapusClaimDecision(index) {
            this.claim_decision.splice(index, 1);
        },

        hapusClaimFile(index) {
            this.lampiran.splice(index, 1);
        },
        onFileChange(event, index) {
            const file = event.target.files[0];
            this.lampiran[index].file = file;
        },


        tambahOrder() {
            this.dataOrder.orders.push({
                orderNo: null,
                customerCode: '',
                customerName: '',
                sapCode: '',
                tanggalOrder: '',
                pickPlan: '',
                pickName: '',
                dropPlan: '',
                dropName: '',
                shipwith_ref: '',
                done: false
            });
        },

        hapusOrder(index) {
            this.dataOrder.orders.splice(index, 1);
        },
        pilihOrder(index, data) {

            this.dataOrder.orders[index].customerCode = data.code;
            this.dataOrder.orders[index].customerName = data.name;
            this.dataOrder.orders[index].sapCode = data.sap_code;
            this.dataOrder.orders[index].tanggalOrder = data.order_date;
            this.dataOrder.orders[index].pickPlan = data.pick_plan;
            this.dataOrder.orders[index].pickName = data.pick_name;
            this.dataOrder.orders[index].dropPlan = data.dest_plan;
            this.dataOrder.orders[index].dropName = data.dest_name;
            this.dataOrder.orders[index].shipwith_ref = data.shipwith_ref;
            console.log(this.dataOrder.orders);
        },

        asyncSearchLoadId(ev) {
            const baseURI = this.$settings.endPoint + `claim/get-data-loadid-claim?load_id=${ev}`;

            return this.$http.get(baseURI).then((response) => {
                this.fetchLoadId = response.data.datas.data;
            });
        },

        openModal() {
            const baseURI = this.$settings.endPointCt + "blujay-order/select";
            this.$http
                .get(baseURI)
                .then((response) => {

                    this.dataModal = {
                        detail: response.data.datas
                    }
                    this.showModalUnloading = true;
                });
        },

        loadBlujay() {
            const baseURI = this.$settings.endPointCt + `blujay-order/select`;

            return this.$http.get(baseURI).then((response) => {
                this.fetchLoadNumber = response.data.datas.data;
            });

        },

        asyncSearchLoadNumber(ev) {
            const baseURI = this.$settings.endPointCt + "blujay-order/select?load_id=" + ev;

            return this.$http.get(baseURI).then((response) => {
                this.fetchLoadNumber = response.data.datas.data;
            });
        },



        // asyncSearchProvinsiTujuan() {
        //   const baseURI = this.$settings.endPoint + "postal-code/select-province/Indonesia";

        //   return this.$http.get(baseURI).then((response) => {
        //     this.fetchProvinsiTujuan = response.data.datas;
        //   });
        // },

        // "blujay_order_id",
        //       "load_number",
        //       "detail_order_id",
        //       "shipment_number",
        //       "shipment_date",
        //       "vehicle_no",
        //       "master_driver_id",
        //       "driver_nmk",
        //       "driver_name",
        //       "driver_hp",
        //       "tanggal_muat",
        //       "tanggal_bongkar",
        //       "provinsi_tujuan",
        //       "kota_tujuan",
        //       "sku",
        //       "route",
        //       "qty",
        //       "qty_return",
        //       "sub_customer",
        //       "description",

        // "blujay_order_id": 3539,
        //             "load_id": "60530857",
        //             "vehicle_no": "B9153FXS",
        //             "driver_nmk": null,
        //             "driver_name": null,
        //             "driver_hp": null,
        //             "name_rute": "pickup :LTLCIKARANG BARAT(GUDANG CML) - LTLLEGOK(PT JAYA SWARASA AGUNG TBK)",
        //             "drop": "LTLLEGOK(PT JAYA SWARASA AGUNG TBK)",
        //             "order_detail_id": 3515,
        //             "shipment_number": "2100437094",
        //             "shipment_date": "2000-01-01 01:01:01",
        //             "state_pick": "BT",
        //             "city": "TANGERANG",
        //             "region": "LEGOK",
        //             "state_drop": "BT",
        //             "vehicle_status": "ACTIVE",
        //             "driver_status": null,
        //             "route": "BT-BT",
        //             "leadtime": 1
        closeMyModal(ev) {
            console.log(ev.master_driver_id)
            if (ev !== null) {
                this.disabledBeforeLoad = false;
                this.forms.master_driver_id = ev.master_driver_id;
                this.forms.blujay_order_id = ev.blujay_order_id;
                this.forms.detail_order_id = ev.order_detail_id;
                this.forms.load_number = ev.load_id;

                this.vehicle_no = {
                    vehicle_no: ev.vehicle_no
                }

                this.forms.driver_nmk = ev.driver_nmk;
                this.forms.driver_name = ev.driver_name;
                this.forms.driver_hp = ev.driver_hp;
                this.forms.route = ev.name_rute;
                this.forms.shipment_number = ev.shipment_number;
                this.forms.shipment_date = ev.shipment_date;
                this.forms.tanggal_muat = ev.shipment_date;
                this.forms.order_number = ev.shipment_number;
                this.forms.driver_id = ev.driver_nmk;
                this.forms.vehicle_owner = ev.branch_name;
                this.driver_id = ev.driver_nmk;
                this.driver_nmk = ev.driver_nmk;



            }

            this.showModalUnloading = false;
        },

        capitalize(value) {
            if (!value) return ''
            value = value.toLowerCase()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },



        isNumberLatLong(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        resetForm() {
            this.forms = "";
        },

        backForm() {

            this.$router.push({ name: 'penerimaan' });
        },

        removeField(index, fieldType) {
            fieldType.splice(index, 1);
        },


        submitData() {
            this.isLoading = true;
            var customer_claimed_date = moment(this.dataKlaim?.customer_claimed_date.startDate).format("YYYY-MM-DD HH:mm:ss");
            // var tglPengajuan = moment(this.dataKlaim?.tglPengajuan.startDate).format("YYYY-MM-DD HH:mm:ss");
            // var tglKejadian = moment(this.dataKlaim?.tglKejadian.startDate).format("YYYY-MM-DD HH:mm:ss");

            // Buat FormData
            let formData = new FormData();


            // decision_claim:CLAIM TO VENDOR TRANSPORT
            // claim_status:KOREKSI
            // total_payment:1350000
            // claim_decision[0][claim_number]:1000348373726
            // claim_decision[0][payment_date]:2025-07-31 12:34:54
            // claim_decision[0][payment_amount]:1350000
            // claim_decision[0][comment]:TEST 1
            // claim_decision[0][currency]:IDR

            // Data utama (string / number)
            formData.append("decision_claim", this.decision_claim || '');
            formData.append("claim_status", this.status_claim?.name || '');
            formData.append("comment", this.dataKlaim.comment || '');
            formData.append("total_payment", this.totalPembayaran);
            formData.append("customer_claimed_date", customer_claimed_date);


            
            // ======================
            // Array claim_order
            // ======================
            let claim_decision_send = [];

            (this.claim_decision || []).forEach((item) => {
                claim_decision_send.push({
                    claim_number: item.claim_number,
                    payment_date: moment(item.payment_date.startDate).format("YYYY-MM-DD HH:mm:ss"),
                    payment_amount: item.payment_amount,
                    comment: item.comment,
                    currency: item.currency,

                });
            });
            // console.log(this.dataOrder?.orders);
            claim_decision_send.forEach((item, index) => {
                Object.keys(item).forEach(key => {
                    formData.append(`claim_decision[${index}][${key}]`, item[key] ?? '');
                });
            });

            // ======================
            // Array claim_detail
            // ======================





            // claim_attachment.forEach((lamp, i) => {
            //     formData.append(`claim_attachment[${i}][attachment_name]`, lamp.nama);

            //     if (lamp.file instanceof File) {
            //     // kalau file sudah diganti (binary)
            //     formData.append(`claim_attachment[${i}][attachment_file]`, lamp.file);
            //     } else {
            //     // kalau masih url (belum diganti)
            //     formData.append(`claim_attachment[${i}][attachment_file]`, lamp.file);
            //     }
            // });

            //console.log(formData);

            // Kirim request ke API
            const baseURI = this.$settings.endPoint + "claim/penerimaan/update-claim/" + this.claim_id;
            this.$http.post(baseURI, formData, {
                headers: { "Content-Type": "multipart/form-data" },
                timeout: 50000
            })
                .then((response) => {
                    this.isLoading = false;
                    if (response.data.status === 200) {
                        this.success('Berhasil');
                        var params = this.$onRandom(this.claim_id);
                        window.location.href =
                            "/claim/penerimaan/detail/" + params + "?status=200&msg=Successfully";
                        this.errors = [];
                    } else {
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                })
                .catch(error => {
                    this.isLoading = false;
                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    } else if (error.response) {
                        if (error.response.status === 422) {
                            // Ambil semua error message dari BE
                            let errors = error.response.data.errors || {};

                            // Gabungkan semua pesan error jadi list HTML
                            let errorMessages = "";
                            Object.keys(errors).forEach(key => {
                                errors[key].forEach(msg => {
                                    errorMessages += `<li>${msg}</li>`;
                                });
                            });

                            this.$swal.fire({
                                icon: "error",
                                title: "Validation Error",
                                html: `<ul style="text-align:left;">${errorMessages}</ul>`,
                                confirmButtonText: "OK",
                            });
                        } else if (error.response.status === 500) {
                            this.error(error.response.data.errors.message);
                        } else {
                            this.$router.push("/page-not-found");
                        }
                    }
                });
        },

        loadCategoriStatus() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=catclm`;
            return this.$http.get(baseURI).then((response) => {
                this.fetchCategoryStatus = response.data.datas;

            });
        },



        fade(sType) {
            this.isLoading = sType;
        },

        changeDriverNmk(driver) {
            this.forms.driver_name = driver.driver_name;
            this.forms.driver_hp = driver.hp1;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.detailUser = userDatas.sub;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == "ClaimPengajuanController") {
                    rolePermision = permision;
                }
            });

            if (!rolePermision.method_create) {
                this.$router.push("/authorized-error");
            }

            this.permision_role = rolePermision;
        },

        loadData(id) {
            const baseURI = this.$settings.endPoint + "claim/penerimaan/detail/" + id;
            return this.$http.get(baseURI).then((response) => {
                // console.log(response);
                var forms = response.data.datas;
                this.loadDriverDeposit(forms.driver_nmk)
                this.claim_id = forms.claim_id;
                //this.status_claim=forms.claim_status;
                this.dataOrder = {
                    loadId: {
                        load_id: forms.load_id,
                    },
                    type_truck: forms.truck_type,
                    nmkDriver: forms.driver_nmk,
                    driver_deposit: 0,
                    driver_number: forms.driver_number,
                    nopol: forms.vehicle_no,
                    namaDriver: forms.driver_name,
                    carrier: forms.carrier,
                    branch_name: forms.branch,
                    orders: [

                    ]
                };

                (forms?.orders || []).forEach((item) => {
                    this.dataOrder.orders.push({
                        orderNo: {
                            order_no: item.order_no,
                        },
                        shipwith_ref: item.shipwith_reff,
                        customerCode: item.customer_code,
                        customerName: item.customer_name,
                        sapCode: item.sap_code,
                        tanggalOrder: item.order_date,
                        pickPlan: item.pick_plan,
                        pickName: item.pick_name,
                        dropPlan: item.dest_plan,
                        dropName: item.dest_name
                    });
                });

                this.status_claim = {
                    name: forms.claim_status
                }


                this.bebanDriver = forms.claim_driver;
                this.bebanVendor = forms.claim_vendor;
                this.bebanKantor = forms.claim_absorb;
                // this.dataKlaim.tglPengajuan = forms.claim_date;
                // this.dataKlaim.tglKejadian = forms.incident_date;
                //this.dataKlaim.jamKejadian=
                const incident_date = forms.incident_date;
                const claim_date = forms.claim_date;
                const [datePart, timePart] = incident_date.split(" ");
                const [datePartClaim] = claim_date.split(" ");
                this.dataKlaim = {
                    aging: forms.aging,
                    status: forms.claim_status,
                    noKlaim: forms.klaim_id,
                    sumberInfo: forms.source_of_information,
                    cabang: forms.branch,
                    nmkDriver: { nmk: forms.driver_nmk },
                    namaDriver: forms.driver_name,
                    type_truck: forms.truck_type,
                    laporan: forms.incident_report,
                    pemeriksaan: forms.incident_result,
                    penyelesaian: forms.incident_settlement,
                    comment: forms.comment,
                    tglPengajuan: datePartClaim,
                    tglKejadian: datePart,
                    jamKejadian: timePart,
                    customer_claimed_date:{
                        startDate: forms.customer_claimed_date,
                        endDate: forms.customer_claimed_date
                    },
                    nopol: {
                        vehicle_no: forms.vehicle_no
                    },
                    details: [
                        // { produk: 'Kertas CME', keterangan: 'Produk Jadi', klaimKe: 'Vendor', kategori: 'Claim DG', jumlah: 42, typePaket: 'Kilogram', harga: 50000 }
                    ]
                };
                console.log(this.dataKlaim);
                (forms?.details || []).forEach((item) => {
                    this.dataKlaim.details.push({
                        produk: item.product_name,
                        produk_id: item.product_id,
                        keterangan: item.product_description,
                        klaimKe: item.claim_to,
                        kategori: item.product_category,
                        jumlah: item.package_qty,
                        typePaket: item.package_type,
                        harga: item.cost_per_package
                    });
                });
                this.lampiran = [

                ];


                (forms?.attachments || []).forEach((item) => {
                    this.lampiran.push({ nama: item.attachment_name, file: item.attachment_file });
                });


                (forms?.decisions || []).forEach((item) => {
                    this.claim_decision.push(
                        {
                            claim_number: item.claim_number,
                            payment_date: { startDate: item.payment_date, endDate: item.payment_date },
                            payment_amount: item.payment_amount,
                            currency: {
                                name: item.currency
                            },
                            comment: item.comment
                        });
                });

                this.decision_claim = forms.claim_decision;

                // this.form={ name: 'asep', usernmae:res.username };
            });
        },
        loadCurrency() {
            const baseURI =
                this.$settings.endPointCt + `master-lookup?unique_id=brmcur`;

            return this.$http.get(baseURI).then((response) => {
                this.fetchCurrency = response.data.datas;

            });
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },
    },
    events: {},
    created: function () { },
    mounted() {

        const formElement = this.$refs.formElement;
        if (formElement) {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'readonly') {
                        const inputs = formElement.querySelectorAll('.multiselect__input');
                        inputs.forEach(input => {
                            input.removeAttribute('readonly');  // Hapus readonly setiap kali diubah
                        });
                    }
                });
            });


            const inputs = formElement.querySelectorAll('.multiselect__input');
            inputs.forEach(input => {
                observer.observe(input, { attributes: true });
            });
        }

        //this.loadLoadId()
        var params = this.$onBehind(this.$route.params.id);
        var id = params[0]; this.loadData(params[0]);
        this.loadData(id)
        this.loadCurrency();
        this.loadKeputusan();
        // this.loadAccidentArea();
        //this.loadCategory();
        // this.loadCause();
        // this.loadRate();
        // this.fetchIt();
        // this.loadBlujay();
        // this.loadVehicleNo();
        // this.loadDriverNmk();
        // this.loadPenyebabLangsung();
        // this.loadCaseResult();
        // this.loadKerusakan();
        // this.loadTipeKejadian();
        // this.loadPenyebabDasar();
        // this.loadDirectCauseDetail();
        // this.loadNmkDriver();
        // this.loadNopol();
        // this.loadSumberInformasi();
    },
};
</script>
<style scoped>
button.gm-ui-hover-effect {
    visibility: hidden;
}



.blur-content {
    filter: blur(5px);
    pointer-events: none;

}

.calendars[data-v-1ebd09d2] {
    display: -webkit-box;
    display: -ms-flexbox;
}

@media screen and (min-width:339px) {
    .daterangepicker.single[data-v-1ebd09d2] {
        min-width: auto
    }

    .daterangepicker.single.show-ranges.show-weeknumbers[data-v-1ebd09d2],
    .daterangepicker.single.show-ranges[data-v-1ebd09d2] {
        min-width: 360px !important
    }
}

.input-group>.form-control,
.input-group>.typeahead.tt-input,
.input-group>.typeahead.tt-hint,
.select2-container--default .select2-search--dropdown .input-group>.select2-search__field,
.input-group>.form-select {
    background: white;
}

.datetimepicker-c {
    height: 35px;
}
</style>